/**
 * Import JavaScript modules
 */

import { copyright, noTabnabbing } from './components/utilities';
import loggedIn from './components/logged-in';
import list from './components/list';
import nav from './components/nav';
import banners from './components/banners';
import search from './components/search';
import author from './components/author';
import authorRecentArticles from './components/author-recent-articles';
import blurbItems from './components/blurb-items';
import articleDetail from './components/article-detail';
import general from './components/general';

/**
 * Execute all imported JavaScript components.
 *
 * @export
 */
export default function() {
  loggedIn();
  nav();
  banners();
  copyright();
  noTabnabbing();
  search();
  author();
  authorRecentArticles();
  blurbItems();
  articleDetail();
  general();

  if (document.querySelectorAll('.mg-list--expandable').length) {
    list();
  }
}



// WEBPACK FOOTER //
// ./assets/src/js/index.js